import { render, staticRenderFns } from "./PkKaroFinancialAffairsConfig.vue?vue&type=template&id=4a27d148&"
import script from "./PkKaroFinancialAffairsConfig.vue?vue&type=script&lang=js&"
export * from "./PkKaroFinancialAffairsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports